import React from 'react';
import './Download.css'
import TableOfContents from '../../components/TableOfContents/TableOfContents';
import { NavLink } from 'react-router-dom';
import SideBar from '../../components/SideBar/SideBar';

interface DownloadProps {
  // Define props here
}

const Download: React.FC<DownloadProps> = () => {

  const s3BaseUrl = "https://overcoming-temptation-public.s3.us-east-1.amazonaws.com"
  const downloadLinks = [
    { language: 'English', fileName: 'Overcoming_Temptation-English.pdf' },
    { language: 'Arabic', fileName: 'Overcoming_Temptation-Arabic.pdf' },
    { language: 'Oriya', fileName: 'Overcoming_Temptation-Oriya.pdf' },
    { language: 'Telugu', fileName: 'Overcoming_Temptation-Telugu.pdf' },
    { language: 'Bengali (Bangla)', fileName: 'Overcoming_Temptation-Bengali.pdf' },
    { language: 'Malayalam', fileName: 'Overcoming_Temptation-Malayalam.pdf' },
  ];

  return (
    <div className="page-container">
      <div className="download">
        <h1>Download</h1>
        <div className="download-list">
          <ul>
            {downloadLinks.map((link, index) => (
              <li key={index}>
                <span className="download-language">
                  {link.language}
                </span>
                {' '}
                <a href={`${s3BaseUrl}/${link.fileName}`} target="_blank" rel="noopener noreferrer" className="download-pdf-link">
                  (pdf)
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="sidebar">
        <SideBar />
      </div>

    </div>
  );
};

export default Download;
